import _ from 'lodash';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

export function GenScale({ answerHistory, data, options, sendAnswer }) {
  const { t } = useTranslation();

  const initAnswer = answerHistory !== undefined ? answerHistory : -1;
  const [answer, setAnswer] = useState(initAnswer);

  const minLabel = options.min ? options.min : data[0].text;
  const maxLabel = options.max ? options.max : data[data.length - 1].text;

  const handleBtnClick = (value) => {
    setAnswer(value);
    sendAnswer(value);
  };

  return (
    <div>
      {_.isEmpty(options.image) && (
        <div className="flex justify-center">
          <div className="bg-secondary-500 flex h-24 items-center justify-center rounded-full w-24">
            <p
              aria-label={
                answer >= 0
                  ? `${t('common.text.selection')} ${data[answer].text}`
                  : ''
              }
              className="text-6xl text-background"
            >
              {answer >= 0 ? data[answer].text : ''}
            </p>
          </div>
        </div>
      )}
      <div className="flex justify-center">
        <div className="inline-flex w-full justify-between">
          <div className="font-light py-2">
            <p>{minLabel}</p>
          </div>
          <div className="font-light py-2">
            <p>{maxLabel}</p>
          </div>
        </div>
      </div>
      <div className="flex justify-center">
        <div className="border border-default-400 inline-flex rounded shadow w-full">
          {data.map((item, index) => (
            <button
              key={item.text}
              onClick={() => handleBtnClick(index)}
              className={`border-2 border-background rounded px-1 sm:py-5 py-1 ${
                answer === index ? 'bg-primary-200' : 'bg-background'
              }`}
              style={{ width: `${100 / data.length}%` }}
            >
              {item.text}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
